import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, ArrowRight, Search } from "lucide-react";
import { listClients } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

export default function Reports() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");

  useEffect(() => {
    listClients()
      .then(setClients)
      .catch(() => toast.error("Erro ao carregar clientes"))
      .finally(() => setLoading(false));
  }, []);

  const filtered = clients.filter((c) =>
    c.name.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div className="space-y-6" data-testid="reports-page">
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-[#0F172A]">
          Fichas de Processo
        </h1>
        <p className="text-sm sm:text-base text-slate-500 mt-1">
          Selecione um cliente para abrir sua ficha de relatório de processos.
        </p>
      </div>

      <div className="relative max-w-md">
        <Search className="h-4 w-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
        <Input
          data-testid="reports-search-input"
          placeholder="Buscar cliente..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="pl-9"
        />
      </div>

      <section className="bg-white border border-slate-200 rounded-xl overflow-hidden">
        {loading ? (
          <div className="p-12 text-center text-slate-400 text-sm">Carregando...</div>
        ) : filtered.length === 0 ? (
          <div className="p-12 text-center" data-testid="empty-reports">
            <FileText className="h-10 w-10 text-slate-300 mx-auto mb-3" />
            <p className="text-sm text-slate-500">
              {clients.length === 0
                ? "Cadastre um cliente antes de criar fichas."
                : "Nenhum cliente corresponde à busca."}
            </p>
          </div>
        ) : (
          <ul className="divide-y divide-slate-100" data-testid="reports-clients-list">
            {filtered.map((c) => (
              <li
                key={c.id}
                className="flex items-center justify-between p-4 hover:bg-slate-50 transition-colors"
                data-testid={`report-client-item-${c.id}`}
              >
                <div>
                  <p className="font-medium text-[#0F172A]">{c.name}</p>
                  <p className="text-xs text-slate-500 mt-0.5">
                    {c.document || "Sem CNPJ/CPF"}
                  </p>
                </div>
                <Button
                  asChild
                  variant="outline"
                  size="sm"
                  data-testid={`open-report-${c.id}`}
                >
                  <Link to={`/fichas/${c.id}`}>
                    Abrir Ficha
                    <ArrowRight className="h-4 w-4 ml-2" />
                  </Link>
                </Button>
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
